"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recaptchaKeyGuard = exports.submitForm = exports.renderFormItems = exports.renderInputType = exports.ErrorType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const SignUpFormConfig_1 = require("../SignUp/SignUpFormConfig");
const index_1 = require("./index");
const Forms_1 = require("../Forms");
const dhsInstallerHelpers_1 = require("Views/Shared/Components/DhsInstaller/helpers/dhsInstallerHelpers");
var ErrorType;
(function (ErrorType) {
    ErrorType["validationError"] = "Front-end validation error";
    ErrorType["serverError"] = "Back-end error";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
const renderInputType = (props, formControl, currentInput, labelTitle, gtmData, selectedCountry, hasError) => {
    const { items: { genericFields, specificFields: { userConsentText }, languages, explanationText, }, inputObject, } = props;
    const placeholder = currentInput && currentInput.placeholder;
    const isLanguage = formControl.key === SignUpFormConfig_1.formControlKeys.language;
    const languagesOption = languages[selectedCountry] || languages[Object.keys(languages)[0]];
    switch (formControl.inputType) {
        case SignUpFormConfig_1.formControlTypes.dropdown:
            const selectOptions = isLanguage ? languagesOption : inputObject[formControl.key].options;
            return ((0, jsx_runtime_1.jsx)(index_1.FormikSelect, { placeholder: placeholder, formControl: formControl, options: selectOptions, labelTitle: labelTitle, currentInput: currentInput, hasError: hasError, required: true }));
        case SignUpFormConfig_1.formControlTypes.input:
            return ((0, jsx_runtime_1.jsx)(index_1.FormikInput, { placeholder: placeholder, formControl: formControl, labelTitle: labelTitle, currentInput: currentInput, hasError: hasError, required: true }));
        case SignUpFormConfig_1.formControlTypes.checkbox:
            return ((0, jsx_runtime_1.jsx)(index_1.FormikCheckbox, { formControl: formControl, explanationText: explanationText, userConsentText: userConsentText, hasError: hasError }));
        case SignUpFormConfig_1.formControlTypes.submit:
            return ((0, jsx_runtime_1.jsx)("div", { className: "flex grid-flow-col justify-items-end max-md:pt-4 pt-6", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "cta cta--large cta--alpha btn-primary btn-large ml-auto", onClick: () => app_1.GTM.newsletter.clickToSignup(gtmData), children: (0, jsx_runtime_1.jsx)("span", { className: "cta-content", children: (0, jsx_runtime_1.jsx)("span", { className: "cta-content-text", children: genericFields.submitLabel }) }) }) }));
    }
};
exports.renderInputType = renderInputType;
const renderFormItems = (props, errors, touched, values, gtmData, formConfig) => {
    const { items: { specificFields: { userConsentValidationMessage, userConsentText }, }, inputObject, } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: "form-inputs", children: formConfig.rows.map((rowConfig, index) => ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 md:grid-cols-2 md:gap-6", children: rowConfig.elements.map((formControl) => {
                const currentInput = inputObject && inputObject[String(formControl.key)];
                const labelTitle = formControl.key === SignUpFormConfig_1.formControlKeys.consentCheckbox
                    ? userConsentText
                    : currentInput === null || currentInput === void 0 ? void 0 : currentInput.label;
                const errorMessage = formControl.key === SignUpFormConfig_1.formControlKeys.consentCheckbox
                    ? userConsentValidationMessage
                    : detectErrorMessage(formControl.key, values, currentInput);
                const renderControl = !(0, dhsInstallerHelpers_1.shouldRenderControl)(formControl, props, values) && 'hidden';
                const hasError = errors[formControl.key] && touched[formControl.key];
                return ((0, jsx_runtime_1.jsxs)("div", { className: `${formControl.className} ${renderControl} form-control-wrapper`, children: [(0, exports.renderInputType)(props, formControl, currentInput, labelTitle, gtmData, values.country, hasError), hasError ? ((0, jsx_runtime_1.jsxs)("div", { className: "error form-helper-text", children: [(0, jsx_runtime_1.jsx)("span", { className: "form-message__error", children: errorMessage }), (0, jsx_runtime_1.jsx)("span", { className: "screen-reader-only hidden", children: errorMessage })] })) : null] }, formControl.key));
            }) }, `${rowConfig.elements}-${index}`))) }));
};
exports.renderFormItems = renderFormItems;
const detectErrorMessage = (formControl, values, currentInput) => {
    switch (formControl) {
        case SignUpFormConfig_1.formControlKeys.email:
            return (0, Forms_1.validateInfoEmail)(values.email)
                ? currentInput === null || currentInput === void 0 ? void 0 : currentInput.emailInfoErrorMessage
                : currentInput === null || currentInput === void 0 ? void 0 : currentInput.errorMessage;
        case SignUpFormConfig_1.formControlKeys.country:
            return (0, Forms_1.validateCountry)(values.country)
                ? currentInput.embargoCountryErrorMessage
                : currentInput === null || currentInput === void 0 ? void 0 : currentInput.errorMessage;
        default:
            return currentInput === null || currentInput === void 0 ? void 0 : currentInput.errorMessage;
    }
};
const submitForm = (data, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, recaptchaToken, pageId) => {
    // Modify form data
    for (const prop in additionalFormData) {
        if (additionalFormData[prop]) {
            data[prop] = additionalFormData[prop];
        }
    }
    if (!data.language) {
        delete data.language;
    }
    const modifiedData = (0, dhsInstallerHelpers_1.modifyFormData)(data);
    modifiedData['sourceUrl'] = app_1.UrlService.GetSourceUrl();
    modifiedData['g-recaptcha-response'] = recaptchaToken;
    const formData = new URLSearchParams(modifiedData).toString();
    const { successMessageText, successMessageTitleText, successMessageButtonLabel, successMessageTextRU, successMessageTitleTextRU, successMessageButtonLabelRU, errorMessageText, errorMessageTitleText, } = specificFields;
    renderSpinner();
    (0, app_1.apiPost)(`${apiUrl}?pageId=${pageId}`, formData).then(response => {
        app_1.GTM.newsletter.subscribe(gtmData);
        if (response.data && response.data.isRUSubscriber) {
            renderMessage(successMessageTitleTextRU, successMessageTextRU, successMessageButtonLabelRU);
        }
        else {
            renderMessage(successMessageTitleText, successMessageText, successMessageButtonLabel);
        }
    }, () => {
        app_1.GTM.newsletter.error(Object.assign(Object.assign({}, gtmData), { errorType: ErrorType.serverError }));
        renderMessage(errorMessageTitleText, errorMessageText);
    });
};
exports.submitForm = submitForm;
const recaptchaKeyGuard = (key) => key && key === app_1.UtilService.getCookie('Recaptcha-Bypass-Key');
exports.recaptchaKeyGuard = recaptchaKeyGuard;
